import { render, staticRenderFns } from "./DictationInput.vue?vue&type=template&id=1d8ee1ca&"
import script from "./DictationInput.vue?vue&type=script&lang=js&"
export * from "./DictationInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports